module.exports = __webpack_public_path__ + "img/bag.f281f553.svg";